import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted } from 'vue'
import { useLocationQuery } from '@/api/locations'
import { useHubs } from '@/common/useHubs'
import { useGetAllHubsOptions, OptionDropdownItem } from '@/api/options'

interface Props {
  accessGrantRequired?: boolean
  locationId?: number | null
  parentLocationId?: number | null
  accessBusinessUnitIds: string[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LocationHubAccess',
  props: {
    accessGrantRequired: { type: Boolean, default: false },
    locationId: { default: null },
    parentLocationId: { default: null },
    accessBusinessUnitIds: { default: () => [] }
  },
  emits: ['updated'],
  setup(__props: any, { emit: emits }) {

const props = __props as { accessGrantRequired: boolean, locationId: number | null, parentLocationId: number | null, accessBusinessUnitIds: string[] }

const { accessibleHubs } = useHubs()
const { data: allHubsOptions } = useGetAllHubsOptions()





const { data: parentLocation } = useLocationQuery(props.parentLocationId)

const hubs = computed(() =>
  allHubsOptions.value
    ?.filter((o) => 'value' in o)
    .map((o) => o as OptionDropdownItem)
    .map((o) => {
      return {
        disabled: !(
          accessibleHubs.value?.map((h) => h.id).includes(o.value) ||
          parentLocation.value?.accessBusinessUnitIds.includes(o.value)
        ),
        ...o,
      }
    })
)

onMounted(() => {
  const defaultHub =
    accessibleHubs.value.length > 0 && accessibleHubs.value[0].id

  if (props.locationId === null && defaultHub) {
    handleAccessUpdate({
      field: 'accessBusinessUnitIds',
      value: [defaultHub],
    })
  }
})

const handleAccessUpdate = (data: unknown) => {
  emits('updated', data)
}

return { __sfc: true,accessibleHubs, allHubsOptions, props, emits, parentLocation, hubs, handleAccessUpdate }
}

})